import { Typography } from "antd"

export function LoginHeading({twoFA, emailNotVerified, phoneNumber="****123", securePass, selectedFactor }){
  return (
    <>
    {
      (!twoFA && !securePass) &&
      <>
        <img alt="logo" src="/assets/logo-fico.png" style={{ width: "250px" }} />
        <Typography.Paragraph>
          <Typography.Text strong>
            Fondo de financiamiento de proyectos para la prevención y fortalecimiento de instituciones
            de seguridad y justicia del empresariado chihuahuense.
          </Typography.Text>
        </Typography.Paragraph>
        <Typography.Paragraph>
        {
          emailNotVerified ? 
          <Typography.Text strong>
            Se ha enviado un correo de verificación a tu dirección de correo electrónico.
            Por favor, verifícalo para que puedas iniciar sesión.
            Esta verificación es necesaria como parte de nuestras nuevas medidas de seguridad.
          </Typography.Text>
          :
          <Typography.Text strong>
            Bienvenido 
          </Typography.Text>
        }
      </Typography.Paragraph>
      </>
    }
      {
        securePass &&
        <Typography.Paragraph>
            <Typography.Text strong>
              Por motivos de seguridad, es necesario que actualices tu contraseña antes de continuar.
              Esta medida ayuda a proteger tu cuenta y garantizar el acceso seguro a la plataforma.
            </Typography.Text>
          </Typography.Paragraph>
      }
      {
        twoFA &&
        <Typography.Paragraph>
          <Typography.Text strong>
            {
              selectedFactor === "sms"
                ? `Ingresa el código de seguridad que mandamos al celular ${phoneNumber}`
                : "Ingresa el código de seguridad que aparece en tu aplicación de autenticación"
            }
          </Typography.Text>
        </Typography.Paragraph>
      }
    </>
  )
}
